import { IconProps } from "./";
import Icon from "./assets/cancel_24.svg";
import { BaseIcon } from "./BaseIcon";

export function Icon24Cancel(props: IconProps) {
  return <BaseIcon icon={<Icon />} {...props} />;
}
